const black = '#222';
const gray = '#9d9d9d';
const nearBlack = '#2a2c2e';
const darkGray = '#3c3c3c';
const labelGray = '#9ba7b3';
const lightGray = '#e0e0e0';
const blueishGray = '#edf0f2';
const gradientGray = '#939699';
const white = '#fff';
const whiteSecondary = '#f0f0f0';
const nearWhite = '#fafdff';
const lightBlue = '#3e8cbb';
const lighterBlue = '#55b6f2';
const gradientGreen = '#26bf66';
const red = '#d64040';
const orange = '#FFA300';

export default {
  white,
  whiteSecondary,
  nearWhite,
  gray,
  nearBlack,
  darkGray,
  lightGray,
  blueishGray,
  labelGray,
  gradientGray,
  black,
  lightBlue,
  lighterBlue,
  gradientGreen,
  red,
  orange,
};
